import axios from 'axios';
import baseUrl from './common';


/**
 * channellogin  - 登录
 * @param  {any} params - loginname & password
 */
export const channellogin = (params:any) => axios({
    url: `${baseUrl}/api/user/login`,
    method: 'post',
    data: params,
});

/**
 * channellogout 退出登录
 *
 */
export const channellogout = () => axios({
    url: `${baseUrl}/api/user/logout`,
    method: 'get',
});
